module.exports = __webpack_public_path__ + "static/media/_COM7.040cdf51.jpg";